import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarCreditosCliente(axios, parametros) {        
    parametros.operacao = 'buscarCreditosCliente';

    let retorno = {};

    await axios.santriGET('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao(false, undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao(true, error, undefined);
    })

    return retorno;
  },

  async validarCreditosUtilizar(axios, parametros) {        
    parametros.operacao = 'validarCreditosUtilizar';

    let retorno = {};

    await axios.santriGET('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao(false, undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao(true, error, undefined);
    })

    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarCreditosCliente.js